export default "__VITE_ASSET__DiN3SdDr__"